import React from 'react'
import { Box } from '@mui/material'
import { useMemberData } from 'team/hooks/useMemberData'
import TeamEditMemberNavbar from 'team/components/editMember/editCardTopNavbar/TeamEditMemberNavbar'
import TeamMemberEditDashboard from './TeamMemberEditDashboard'
import TeamMemberEditLoading from 'team/components/editMember/TeamMemberEditLoading'

const TeamMemberEditContainer = ({ user: currentUser }) => {
    const { displayUser, loading } = useMemberData(currentUser)

    if (loading) {
        return <TeamMemberEditLoading />
    }

    return (
        <Box sx={{ height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ flexShrink: 0 }}>
                <TeamEditMemberNavbar user={displayUser} />
            </Box>
            <Box sx={{ flex: 1, overflow: 'hidden' }}>
                <TeamMemberEditDashboard user={displayUser} />
            </Box>
        </Box>
    )
}

export default TeamMemberEditContainer